import React from 'react';

export default function MinimalLanding() {
  return (
    <div className="main-container">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Alegreya:ital,wght@0,400;0,700;1,400&display=swap');

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: "Alegreya", serif;
          background-color: white;
          text-rendering: optimizeLegibility;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          font-feature-settings: "liga" 1, "kern" 1;
        }

        .main-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 1.25rem;
          margin: 0 auto;
          min-height: 100vh;
          background-color: white;
        }

        .message-section {
          margin: auto;
          text-align: center;
          max-width: 100%;
          padding: 0 1.25rem;
        }

        .title {
          margin-bottom: 0.25rem;
          font-size: 1.875rem;
          font-weight: 700;
          color: #374151;
          white-space: nowrap;
        }

        .subtitle {
          font-size: 1.875rem;
          color: #374151;
          white-space: nowrap;
        }

        .subtitle em {
          font-style: italic;
        }

        .footer {
          position: fixed;
          bottom: 35px;
          font-size: 0.875rem;
          text-align: center;
          color: #374151;
        }

        /* Media Queries */
        @media (max-width: 991px) {
          .title,
          .subtitle {
            font-size: 1.5rem;
          }
        }

        @media (max-width: 640px) {
          .message-section {
            padding: 0 1rem;
            max-width: 100%;
          }

          .title {
            font-size: 1rem;
            margin-bottom: 0.125rem;
          }

          .subtitle {
            font-size: 1rem;
            white-space: nowrap;
          }

          .footer {
            bottom: 1.25rem;
            font-size: 0.75rem;
          }
        }
      `}</style>

      <header className="message-section">
        <h1 className="title">What action can quench the fire of burnout?</h1>
        <p className="subtitle">
          Watering <em>can</em>.
        </p>
      </header>
      <footer className="footer">© 2026 Watering Can</footer>
    </div>
  );
}
